import React, { Component } from 'react'
import { graphql, compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router'
import {
  GetAppointments,
  GetAllNoteTypes,
  GetCompositionMetadataById,
  UpdateCompositionStatus,
  LockNoteForEdit
} from '@sukiai/gql/app'
import { Constants } from '@sukiai/components'
import {
  GET_SCHEDULE_DATE,
  UPDATE_SCHEDULE_DATE,
  SET_AGENT_SIZE,
  SET_AGENT_POSITION,
  SET_MODAL,
  SET_NOTES_LIST,
  SHOULD_UPDATE_SCHEDULE,
  SET_NOTE_CREATED_PENDING
} from '../../apollo/actions'
import { getStreamWorker } from '../../ws/stream'
import { DataCommand } from '../../ws/DataCommand'
import moment from 'moment'
import {
  ROUTES,
  LO_STO,
  sortItemsByKey,
  HALF_STORY,
  FETCH_POLICY,
  NOTE_QUEUE_STATUS,
  openProcessingNote,
  setCompBeingCreated,
  getCompBeingCreated
} from '../../lib'
import loSto from '../../config/loSto'
import { halfStory as hs } from '../../lib/logging'
import { whiteSmoke } from '@sukiai/components/lib/colors'
import DayPicker from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import { pickerCss, WEEKDAYS } from './dayPickerOverrides'
import get from 'lodash/get'
import ScheduleContainer from './ScheduleContainer'

const {
  AGENT,
  MODALS,
  DIMENSIONS,
  NOTE_STATUS
} = Constants
const { LIST_CELL_TWO } = DIMENSIONS
const EMPTY_LIST = (LIST_CELL_TWO * 3) + 2

const styles = {
  picker: {
    background: whiteSmoke,
    position: 'absolute',
    top: 20,
    left: '50%',
    transform: 'translateX(-50%)',
    boxShadow: '0px 2px 10px rgba(0,0,0,0.3)',
    zIndex: 1
  },
  pickerVeil: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh'
  }
}

class Schedule extends Component {
  state = {
    calcheight: EMPTY_LIST,
    pickerOpen: false
  }

  componentDidMount () {
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('beforeunload', this.saveScheduleDate)
    window.addEventListener('mousedown', this.handleClicks)
  }

  componentWillUnmount () {
    const { scheduleDate, setNotesList } = this.props

    loSto.set(LO_STO.SCHEDULE_DATE, scheduleDate)
    setNotesList([], [])
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('beforeunload', this.saveScheduleDate)
    window.removeEventListener('mousedown', this.handleClicks)
    setCompBeingCreated(false)
  }

  handleClicks = (e) => {
    const { pickerOpen } = this.state

    if (!pickerOpen) {
      return
    }

    const isDatePicker = e.target.closest('.DayPicker')
    if (!isDatePicker) {
      this.setState({ pickerOpen: false })
    }
  }

  saveScheduleDate = () => {
    loSto.set(LO_STO.SCHEDULE_DATE, this.props.scheduleDate)
    return null
  }

  handleKeyDown = ({ key }) => {
    const {
      scheduleDate,
      updateScheduleDate
    } = this.props

    if (key === 'ArrowLeft') {
      updateScheduleDate(moment(scheduleDate).subtract(1, 'days').format())
    } else if (key === 'ArrowRight') {
      updateScheduleDate(moment(scheduleDate).add(1, 'days').format())
    } else if (key === ' ') {
      updateScheduleDate(moment().format())
    }
  }

  togglePicker = open => {
    this.setState({ pickerOpen: open })
  }

  handleDayClick = day => {
    const { updateScheduleDate } = this.props
    this.togglePicker(false)
    updateScheduleDate(moment(day).format())
  }

  componentWillReceiveProps (nextProps) {
    const { client } = this.props

    if (nextProps.appointmentsLoading) {
      if (nextProps.appointmentsCount && nextProps.appointmentsCount > 2) {
        this.setState({
          calcheight: (nextProps.appointmentsCount * LIST_CELL_TWO) + (nextProps.appointmentsCount - 1)
        })
      } else {
        this.setState({
          calcheight: EMPTY_LIST
        })
      }
    } else if (nextProps.appointmentsCount && nextProps.appointmentsCount > 2) {
      this.setState({
        calcheight: (nextProps.appointmentsCount * LIST_CELL_TWO) + (nextProps.appointmentsCount - 1)
      })
    } else {
      this.setState({
        calcheight: EMPTY_LIST
      })
    }

    // Currently used when scribe edits a section - the section status may change
    if (nextProps.shouldUpdate !== this.props.shouldUpdate) {
      client.query({
        query: GetAppointments,
        variables: {
          ownerId: loSto.get(LO_STO.USER_ID),
          startsAtRangeBeginning: moment(nextProps.scheduleDate).startOf('day').toISOString(),
          startsAtRangeEnd: moment(nextProps.scheduleDate).endOf('day').toISOString()
        },
        fetchPolicy: FETCH_POLICY.NETWORK_ONLY
      }).then(({ data }) => {
        client.writeQuery({
          query: GetAppointments,
          data: data
        })
      })
    }

    if (nextProps.appointmentsData && nextProps.appointmentsData !== this.props.appointmentsData) {
      const compositionIds = []
      const patientNoteIds = []
      nextProps.appointmentsData && nextProps.appointmentsData.forEach(appointment => {
        if (appointment.noteId) {
          patientNoteIds.push(appointment.noteId)
        } else if (appointment.compositionId) {
          compositionIds.push(appointment.compositionId)
        }
      })
      nextProps.setNotesList(compositionIds, patientNoteIds)
    }
  }

  onApptClick = async appt => {
    const {
      history,
      setAgentPosition,
      client,
      lockNoteForEdit
    } = this.props

    let { id, noteStatus, compositionId, patient } = appt
    hs.add(HALF_STORY.CLICK, `Clicked on appointment ${id}`)

    // Check in case of stale note status
    if (
      noteStatus &&
      noteStatus !== NOTE_STATUS.SUBMITTED_TO_EMR &&
      noteStatus !== NOTE_STATUS.IMPORTED_FROM_EMR
    ) {
      const { data } = await client.query({
        query: GetCompositionMetadataById,
        variables: { id: compositionId },
        fetchPolicy: FETCH_POLICY.NETWORK_ONLY
      })

      noteStatus = get(data, 'compositions.results[0].metadata.status')

      if (noteStatus === NOTE_STATUS.SUBMITTED_TO_EMR || noteStatus === NOTE_STATUS.IMPORTED_FROM_EMR) {
        this.openPatientNote(appt)
      } else if (noteStatus === NOTE_STATUS.USER_IS_DONE) {
        // check if note is already being processed by scribe
        const isNoteBeingProcessed = await lockNoteForEdit({
          variables: { noteId: compositionId }
        }).then(({ data }) => {
          const status = get(data, 'lockNoteForEdit.status')
          return status === NOTE_QUEUE_STATUS.NOTE_IS_BEING_EDITED
        })

        if (isNoteBeingProcessed) {
          openProcessingNote(compositionId)
          return
        }
        loSto.set(LO_STO.CURRENT_COMP_ID, compositionId)
        loSto.remove(LO_STO.CURRENT_NOTE_ID)
        loSto.set(LO_STO.CURRENT_PATIENT_ID, patient.id)
        history.push(`${ROUTES.NOTE}/${compositionId}`)

        // todo temporary commented modal till same functional will be implemented on other platforms
        // Show a modal indicating that the user needs to hit I'm done, to make sure the note gets processed again
        /*        client.mutate({
          mutation: SET_MODAL,
          variables: {
            content: {
              __typename: 'ModalContent',
              type: MODALS.ERROR,
              heading: 'Review note',
              body: 'You are editing a note already submitted for processing. Please press the "I\'m Done" button again, after reviewing the note.'
            }
          }
        }) */

        setAgentPosition(AGENT.POSITION.LEFT)
      } else {
        loSto.set(LO_STO.CURRENT_COMP_ID, compositionId)
        loSto.remove(LO_STO.CURRENT_NOTE_ID)
        loSto.set(LO_STO.CURRENT_PATIENT_ID, patient.id)
        history.push(`${ROUTES.NOTE}/${compositionId}`)
      }
    } else if (noteStatus === NOTE_STATUS.SUBMITTED_TO_EMR || noteStatus === NOTE_STATUS.IMPORTED_FROM_EMR) {
      this.openPatientNote(appt)
    } else {
      this.openNoteTypeSelection(id, patient.id)
    }
  }

  openPatientNote = appt => {
    const {
      setAgentPosition,
      setAgentSize,
      setModal
    } = this.props

    if (appt.compositionId) {
      loSto.set(LO_STO.CURRENT_COMP_ID, appt.compositionId)
      loSto.remove(LO_STO.CURRENT_NOTE_ID)
    } else {
      loSto.set(LO_STO.CURRENT_NOTE_ID, appt.noteId)
      loSto.remove(LO_STO.CURRENT_COMP_ID)
    }

    setAgentPosition(AGENT.POSITION.LEFT)
    setAgentSize(AGENT.SIZE.LARGE)
    setModal({
      __typename: 'ModalContent',
      type: MODALS.READ_NOTE
    })
  }

  openNoteTypeSelection = async (appointmentId, patientId) => {
    const {
      client
    } = this.props

    // TODO: Eventually move to using link state for these
    loSto.set(LO_STO.CURRENT_APPT_ID, appointmentId)
    loSto.set(LO_STO.LAST_OPENED_APPT, appointmentId)
    loSto.set(LO_STO.CURRENT_PATIENT_ID, patientId)

    client.mutate({
      mutation: SET_NOTE_CREATED_PENDING,
      variables: {
        isPending: true
      }
    })

    const stream = getStreamWorker()
    stream && stream.postMessage({
      cmd: DataCommand.USER_REQUEST,
      userRequestType: 'CREATE_NOTE',
      userRequestData: {},
      ts: new Date().toISOString()
    })

    if (await getCompBeingCreated()) return
    setCompBeingCreated(true)
  }

  render () {
    const {
      scheduleDate,
      updateScheduleDate,
      appointmentsLoading,
      appointmentsCount,
      appointmentsData,
      handleModeChange,
      showFullTabs
    } = this.props

    return (
      <div style={{ width: '100vw', fontSize: 16 }}>
        <ScheduleContainer
          type='SCHEDULE'
          title={moment(scheduleDate).format('MMMM D, YYYY')}
          dateString={moment(scheduleDate).format('dddd, MMMM DD, YYYY')}
          day={moment(scheduleDate).format('dddd')}
          changeDate={updateScheduleDate}
          loading={appointmentsLoading && !appointmentsData}
          count={appointmentsCount}
          appointments={appointmentsData}
          handleApptClick={this.onApptClick}
          lastApptOpened={loSto.get(LO_STO.LAST_OPENED_APPT)}
          openNoteTypeSelection={this.openNoteTypeSelection}
          calcheight={this.state.calcheight}
          togglePicker={() => this.togglePicker(true)}
          handleModeChange={handleModeChange}
          showFullTabs={showFullTabs}
        >
          {this.state.pickerOpen &&
            <div style={styles.picker}>
              <style>{pickerCss}</style>
              <DayPicker
                onDayClick={this.handleDayClick}
                selectedDays={new Date(scheduleDate)}
                initialMonth={new Date(scheduleDate)}
                showOutsideDays
                weekdaysLong={WEEKDAYS}
                weekdaysShort={WEEKDAYS}
                onCaptionClick={() => this.togglePicker(false)}
              />
            </div>}
        </ScheduleContainer>
      </div>
    )
  }
}

const mapAppointmentsToProps = ({ data, ownProps: { client, scheduleDate } }) => {
  let appointmentsLoading = data.loading
  let appointmentsData = data.appointments && data.appointments.results
  // TODO [Mark] This is a hack to check whether the appointments are cached in the
  // in-memory apollo cache before displaying data
  try {
    client.readQuery({
      query: GetAppointments,
      variables: {
        ownerId: loSto.get(LO_STO.USER_ID),
        startsAtRangeBeginning: moment(scheduleDate).startOf('day').toISOString(),
        startsAtRangeEnd: moment(scheduleDate).endOf('day').toISOString()
      }
    })
  } catch (e) {
    appointmentsLoading = true
    appointmentsData = null
  }
  return {
    appointmentsError: data.error,
    appointmentsLoading: appointmentsLoading,
    appointmentsCount: data.appointments && data.appointments.count,
    appointmentsData: appointmentsData
  }
}

const mapNoteTypesToProps = ({ data }) => ({
  noteTypesError: data.error,
  noteTypesLoading: data.loading,
  noteTypesCount: data.noteTypes && data.noteTypes.count,
  noteTypesData: data.noteTypes && sortItemsByKey(data.noteTypes.results.slice(), 'name')
})

export default compose(
  withApollo,
  withRouter,
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize => mutate({
        variables: { agentSize }
      })
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition => mutate({
        variables: { agentPosition }
      })
    })
  }),
  graphql(SET_MODAL, {
    props: ({ mutate }) => ({
      setModal: content => mutate({
        variables: { content }
      })
    })
  }),
  graphql(SET_NOTES_LIST, {
    props: ({ mutate }) => ({
      setNotesList: (compositionIds, patientNoteIds) => mutate({
        variables: {
          compositionIds,
          patientNoteIds
        }
      })
    })
  }),
  graphql(GET_SCHEDULE_DATE, {
    props: ({ data: { scheduleDate } }) => ({
      scheduleDate: scheduleDate.date
    })
  }),
  graphql(UPDATE_SCHEDULE_DATE, {
    props: ({ mutate }) => ({
      updateScheduleDate: date => mutate({ variables: { date } })
    })
  }),
  graphql(SHOULD_UPDATE_SCHEDULE, {
    props: ({ data: { shouldUpdateSchedule } }) => ({
      shouldUpdate: shouldUpdateSchedule
    })
  }),
  graphql(LockNoteForEdit, { name: 'lockNoteForEdit' }),
  graphql(UpdateCompositionStatus, { name: 'updateCompositionStatus' }),
  graphql(GetAppointments, {
    skip: ({ scheduleDate }) => !loSto.get(LO_STO.USER_ID) || !scheduleDate,
    options: ({ scheduleDate }) => ({
      variables: {
        ownerId: loSto.get(LO_STO.USER_ID),
        startsAtRangeBeginning: moment(scheduleDate).startOf('day').toISOString(),
        startsAtRangeEnd: moment(scheduleDate).endOf('day').toISOString()
      },
      fetchPolicy: FETCH_POLICY.CACHE_AND_NETWORK
    }),
    pollInterval: 5000,
    props: mapAppointmentsToProps
  }),
  graphql(GetAllNoteTypes, {
    options: () => ({
      variables: {
        userId: loSto.get(LO_STO.USER_ID)
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }),
    props: mapNoteTypesToProps
  })
)(Schedule)
